import { render, staticRenderFns } from "./marketPay.vue?vue&type=template&id=096180c8&scoped=true"
import script from "./marketPay.vue?vue&type=script&lang=js"
export * from "./marketPay.vue?vue&type=script&lang=js"
import style0 from "./marketPay.vue?vue&type=style&index=0&id=096180c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096180c8",
  null
  
)

export default component.exports